import React, { useState } from 'react';
import bemCn from 'bem-cn';
import { NAV_ALT } from '../navigation/navigation.consts';
import useMobileScreen from '../../services/hooks/useMobileScreen';
import { RouteFormatter } from '../../routes';
import PictureSet from '../picture-set';
import logoMin from '../../assets/img/sniffspot-logo-min.png';
import logo from '../../assets/img/sniffspot-logo-app.png';
import SvgChevronLeft from 'src/assets/svg/SvgChevronLeft.svg';
import SvgSnifLogo from 'src/assets/svg/SvgSnifLogo.svg';
import './style.scss';

const b = bemCn('navigation-logo');

const RenderDefaultComp = ({ className, full, isApp, width, height, src }) => (
    <a href={RouteFormatter.home()} className={className}>
        {full && !isApp ? (
            <SvgSnifLogo height={32} className="ms-2" />
        ) : (
            <PictureSet imgs={src} SSR={true} useState={useState} alt={NAV_ALT} className={b('img')} width={width} height={height} method="eager" />
        )}
    </a>
);

const RenderSpotComp = ({ handleBack, spotTitle }) => (
    <>
        <div className={b('back-btn')} onClick={handleBack}>
            <SvgChevronLeft />
        </div>
        <div className="nav-title snif-s1 snif-medium spot-detail" style={{ textTransform: 'capitalize' }}>
            {spotTitle}
        </div>
    </>
);

const NavigationLogoSSR = (props = {}) => {
    const isMobile = useMobileScreen();
    const { className = '', full, isApp, isSpotPage } = props;
    const src = isMobile ? logoMin : logo;
    const width = isMobile ? 50 : 183;
    const height = isMobile ? 34 : 34;
    const spotTitle = isSpotPage ? props.spot?.title || props.spot?.parkName : '';

    const handleBack = () => {
        const referrer = document.referrer;
        const canGoBack = referrer && new URL(referrer).origin === window.location.origin;

        if (canGoBack && window.history.length > 1) {
            window.history.back();
        } else {
            window.location.replace(RouteFormatter.listings({}));
        }
    };

    if (isSpotPage) {
        return <RenderSpotComp {...{ handleBack, spotTitle }} />;
    }

    return <RenderDefaultComp {...{ className, full, isApp, width, height, src }} />;
};

export default NavigationLogoSSR;
